module.exports = __webpack_public_path__ + "img/chevron-backward-aaccordion.8ffca918.svg";